<template lang="html">
    <ModalDefault
        v-if="params.isActive"
        size="s"
        :with-content="true"
        @close="no();"
        :theme="true"
        :fix-height="false"
        :fix-width="false"
        :loading="false"
    >
        <template slot="main">
            <p class="modal-title">{{ $t("common.upload") }}</p>

            <span>{{ $t("catalogForecast.market.warningUpload") }}</span>
            <div class="table-responsive my-4">
                <table>
                    <tr v-for="upload in params.uploads">
                        <td>{{ upload.by.firstname + " " + upload.by.lastname }}</td>
                        <td class="text-center">{{ moment(upload.date).format($t("common.dateTimeFormat")) }}</td>
                    </tr>
                </table>
            </div>
            <p class="waring-2">{{ $t("catalogForecast.market.warningUpload2") }}</p>
            <p class="waring-3">{{ $t("catalogForecast.market.warningUpload3") }}</p>

            <div class="row mt-5">
                <div class="col d-flex justify-content-center">
                    <ClientColorButton :inactiveColor="true" @click.prevent="no();" class="mr-4"> {{ $t("wishlist.btNo") }} </ClientColorButton>
                    <ClientColorButton :background-color="currentBrand.linksColor" @click.prevent="yes();">
                        {{ $t("wishlist.btYes") }}
                    </ClientColorButton>
                </div>
            </div>
        </template>
    </ModalDefault>
</template>

<script lang="js">
import ModalDefault from "@/components/ui/ModalDefault";
import DefaultTextareaInputBloc from "@/components/ui/Form/DefaultTextareaInputBloc";
import * as moment from "moment/moment";
import {mapState} from "vuex";

export default {
    components: {DefaultTextareaInputBloc, ModalDefault},
    props: ['params'],
    data () {
        return {
            moment
        }
    },
    methods: {
        no() {
            this.params.isActive = false;
            this.$emit('no');
        },
        yes() {
            this.params.isActive = false;
            this.$emit('yes');
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
    }
}
</script>

<style scoped lang="scss">
span {
    font-size: 16px;
    text-transform: initial;
}
.waring-2 {
    font-size: 24px;
    font-weight: bold;
}
.waring-3 {
    font-size: 16px;
    color: red;
    margin: 0;
}
.table-responsive {
    max-height: 338px;
    overflow: auto;

    table {
        width: 100%;

        tr {
            td {
                border: 1px solid #2d2d2d;
                padding: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// UploadInfos.vue?4b4c98f2